/**
 * Coherencia paradero ↔ recorrido (prefijos PAI-T1-* … PAI-T5A-* en catálogos JSON).
 */

import t1Paradas from '@/data/paradas/t1Paradas.json';
import t2Paradas from '@/data/paradas/t2Paradas.json';
import t3Paradas from '@/data/paradas/t3Paradas.json';
import t4Paradas from '@/data/paradas/t4Paradas.json';
import t5aParadas from '@/data/paradas/t5aParadas.json';
import t5bParadas from '@/data/paradas/t5bParadas.json';

/** Texto único: mapa inactivo, franja GPS y tarjetas deshabilitadas en landing. */
export const MENSAJE_BUS_REEMPLAZO_SIN_TIEMPO_REAL =
  'Bus de reemplazo. No es posible entregar una ubicación en tiempo real.';

/**
 * Fila de GET /api/trayectos: `activo === false` cuando el admin desactivó el tramo.
 * @param {{ activo?: unknown } | null | undefined} row
 */
export function trayectoCatalogoInactivo(row) {
  if (!row) return false;
  const a = row.activo;
  if (a === false) return true;
  if (a === 'false' || a === 0) return true;
  return false;
}

/**
 * @param {string | null | undefined} paraderoId
 * @param {string | null | undefined} recorridoId
 * @returns {boolean} false si el recorrido tiene catálogo y el id no es de esa familia
 */
export function paraderoMatchesRecorridoCatalog(paraderoId, recorridoId) {
  const r = (recorridoId || '').toLowerCase();
  const p = (paraderoId || '').trim();
  if (r === 't1a' || r === 't1b') return p.startsWith('PAI-T1-');
  if (r === 't2') return p.startsWith('PAI-T2-');
  if (r === 't3') return p.startsWith('PAI-T3-');
  if (r === 't4') return p.startsWith('PAI-T4-');
  if (r === 't5a') return p.startsWith('PAI-T5A-');
  if (r === 't5b') return p.startsWith('PAI-T5B-');
  return true;
}

/**
 * Primer paradero «cabecera» por recorrido (misma lógica que landing).
 * @param {string | null | undefined} recorridoId
 */
export function defaultParaderoIdForRecorrido(recorridoId) {
  const r = (recorridoId || '').toLowerCase();
  if (r === 't2') return 'PAI-T2-IDA-001';
  if (r === 't3') return 'PAI-T3-IDA-001';
  if (r === 't4') return 'PAI-T4-IDA-001';
  if (r === 't5a') return 'PAI-T5A-IDA-001';
  if (r === 't5b') return 'PAI-T5B-IDA-001';
  return 'PAI-T1-IDA-001';
}

/**
 * Cabecera ida del recorrido (coords + id) para centrar mapa / buses/near sin URL de paradero.
 * @param {string | null | undefined} recorridoId
 * @returns {{ id: string, nombre: string, lat: number, lng: number }}
 */
export function mapAnchorParaderoForRecorrido(recorridoId) {
  const r = (recorridoId || 't1a').toLowerCase();
  const fallback = { id: 'anchor-fallback', nombre: 'Paine', lat: -33.808463, lng: -70.739346 };
  /** @type {Record<string, { ida?: Array<{ id: string, nombre: string, lat: number, lng: number }> }>} */
  const table = {
    t1a: t1Paradas,
    t1b: t1Paradas,
    t2: t2Paradas,
    t3: t3Paradas,
    t4: t4Paradas,
    t5a: t5aParadas,
    t5b: t5bParadas,
  };
  const key = r === 't1' ? 't1a' : r;
  const raw = table[key];
  const first = raw?.ida?.[0];
  if (!first?.lat || !first?.lng) return fallback;
  return {
    id: first.id,
    nombre: first.nombre || '',
    lat: first.lat,
    lng: first.lng,
  };
}
